import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="bg-primary-dark text-text-dark py-20 md:py-32 relative overflow-hidden" data-id="element-176">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-accent/5 blur-3xl rounded-full pointer-events-none" data-id="element-177"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-178">
        <FadeIn data-id="element-179">
          <div className="text-center" data-id="element-180">
            <h2 className="text-4xl md:text-6xl font-black mb-8 text-white" data-id="element-181">
              En solo <span className="text-accent" data-id="element-182">7 días</span>, el peso
              emocional de tu trabajo se reduce a la mitad.
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 mt-12" data-id="element-183">
          <FadeIn delay={0.2} data-id="element-184">
            <p className="text-xl leading-relaxed text-text-muted border-l-4 border-secondary-dark pl-6" data-id="element-185">
              No porque el trabajo cambie, sino porque vos{' '}
              <strong className="text-white" data-id="element-186">
                dejás de ser un blanco fácil
              </strong>{' '}
              para el estrés.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-187">
            <p className="text-xl leading-relaxed text-text-muted border-l-4 border-accent pl-6" data-id="element-188">
              Recuperás la claridad mental para decidir tu próximo paso
              profesional desde la{' '}
              <strong className="text-accent" data-id="element-189">calma</strong>, no desde la
              desesperación.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}